import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Form, Select } from "antd";

import { selectProvidersFacility } from "../../../../../store/selector";
import { SingleSelect } from "../../../../customComponent/CustomSelect";
import { OTHER, STATE } from "../../constants";
import { getFieldsToUpdateOnProviderChange } from "../../utils/provider";
import useConditionalValidation from "./utils/useConditionalValidation";
import { getStateCode } from "../../../../../constant/states";

const { Option } = Select;

export const GenericFacilityItem = ({
  label,
  required,
  rules = [],
  placeholder,
  allowOther,
  formToFacilityFieldMap,
  form,
  shouldValidateFields = false,

  ...props
}) => {
  useConditionalValidation(props.name, shouldValidateFields);
  const { t } = useTranslation();
  const facilities = useSelector(selectProvidersFacility);
  const selectedFacility = Form.useWatch(props.name, form);
  const formSectionName = props.name[0];

  useEffect(() => {
    if (selectedFacility) {
      form.validateFields([props.name]);
    }
  }, [selectedFacility]);

  const updateFormOnFacilityChange = async (facilityName, option) => {
    if (option.key === "other") {
      form.setFieldsValue({ [props.name]: OTHER });
      return;
    }
    const facilityId = Number(option.key);
    const fieldsToUpdate = getFieldsToUpdateOnProviderChange(facilities, facilityId, formToFacilityFieldMap);

    if (fieldsToUpdate[STATE]) {
      fieldsToUpdate[STATE] = getStateCode(fieldsToUpdate[STATE]);
    }

    form.setFieldsValue({ [formSectionName]: { ...fieldsToUpdate } });
  };

  return (
    <Form.Item name={props.name} label={label} rules={[{ required }, ...rules]}>
      <SingleSelect
        useCommonStyle={false}
        listHeight={200}
        bordered
        placeholder={placeholder}
        onChange={updateFormOnFacilityChange}
      >
        {facilities?.map((facility) => (
          <Option key={facility.id} value={facility.name}>
            {facility.name}
          </Option>
        ))}
        {allowOther && (
          <Option key="other" value={OTHER}>
            {t("other")}
          </Option>
        )}
      </SingleSelect>
    </Form.Item>
  );
};
